// import axios from 'axios';
import axios from '../../utils/axiosConfig';
import {
  TIMESHEET_CREATE_REQUEST,
  TIMESHEET_CREATE_SUCCESS,
  TIMESHEET_CREATE_FAIL,
  TIMESHEET_LIST_REQUEST,
  TIMESHEET_LIST_SUCCESS,
  TIMESHEET_LIST_FAIL,
  TIMESHEET_DETAILS_REQUEST,
  TIMESHEET_DETAILS_SUCCESS,
  TIMESHEET_DETAILS_FAIL,
  TIMESHEET_UPDATE_REQUEST,
  TIMESHEET_UPDATE_SUCCESS,
  TIMESHEET_UPDATE_FAIL,
  TIMESHEET_DELETE_REQUEST,
  TIMESHEET_DELETE_SUCCESS,
  TIMESHEET_DELETE_FAIL
} from '../constants/timesheetConstants';

export const createTimesheet = (timesheet) => async (dispatch) => {
  try {
    dispatch({ type: TIMESHEET_CREATE_REQUEST });
    const { data } = await axios.post('/api/timesheets', timesheet);
    dispatch({ type: TIMESHEET_CREATE_SUCCESS, payload: data });
    // Immediately re-fetch all timesheets
    dispatch(listTimesheets());
  } catch (error) {
    dispatch({ type: TIMESHEET_CREATE_FAIL, payload: error.response.data.message });
  }
};

export const listTimesheets = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: TIMESHEET_LIST_REQUEST });
    
    // Build query string from filters
    const queryParams = new URLSearchParams();
    if (filters.owner) queryParams.append('owner', filters.owner);
    if (filters.fileCase) queryParams.append('fileCase', filters.fileCase);
    if (filters.isBilled !== undefined) queryParams.append('isBilled', filters.isBilled);
    if (filters.startDate) queryParams.append('startDate', filters.startDate);
    if (filters.endDate) queryParams.append('endDate', filters.endDate);
    if (filters.search) queryParams.append('search', filters.search);
    if (filters.limit) queryParams.append('limit', filters.limit);
    if (filters.page) queryParams.append('page', filters.page);
    
    const queryString = queryParams.toString();
    const url = queryString ? `/api/timesheets?${queryString}` : '/api/timesheets';
    
    const { data } = await axios.get(url);
    
    // Handle both old format (array) and new format (object with timesheets array)
    const timesheets = Array.isArray(data) ? data : (data.timesheets || []);
    
    dispatch({ type: TIMESHEET_LIST_SUCCESS, payload: timesheets });
  } catch (error) {
    dispatch({ type: TIMESHEET_LIST_FAIL, payload: error.message });
  }
};




export const getTimesheetsByCaseId = (id) => async (dispatch) => {
  try {
    dispatch({ type: TIMESHEET_LIST_REQUEST });
    const res = await axios.get(`/api/timesheets/case/${id}`);
    dispatch({ type: TIMESHEET_LIST_SUCCESS, payload: res.data });
  } catch (error) {
    dispatch({ type: TIMESHEET_LIST_FAIL, payload: error.message });
  }
};

export const getTimesheetDetails = (id) => async (dispatch) => {
  try {
    dispatch({ type: TIMESHEET_DETAILS_REQUEST });
    const { data } = await axios.get(`/api/timesheets/${id}`);
    dispatch({ type: TIMESHEET_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: TIMESHEET_DETAILS_FAIL, payload: error.response.data.message });
  }
};

export const updateIsBilled = (timesheetIds, isBilled) => async (dispatch) => {
  try {
    console.log(timesheetIds, isBilled);
    await axios.put('/api/timesheets', { timesheetIds, isBilled });
  } catch (error) {
    console.error(error);
  }
}

export const updateTimesheet = (timesheet) => async (dispatch) => {
  try {
    dispatch({ type: TIMESHEET_UPDATE_REQUEST });
    const { data } = await axios.put(`/api/timesheets/${timesheet._id}`, timesheet);
    dispatch({ type: TIMESHEET_UPDATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: TIMESHEET_UPDATE_FAIL, payload: error.response.data.message });
  }
};

export const deleteTimesheet = (id) => async (dispatch) => {
  try {
    dispatch({ type: TIMESHEET_DELETE_REQUEST });
    const { data } = await axios.delete(`/api/timesheets/${id}`);
    dispatch({ type: TIMESHEET_DELETE_SUCCESS, payload: data.message || 'Timesheet deleted successfully' });
    return true; // Return success status for component handling
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to delete timesheet';
    dispatch({ type: TIMESHEET_DELETE_FAIL, payload: errorMessage });
    console.error('Error deleting timesheet:', errorMessage);
    return false; // Return failure status for component handling
  }
};